import { baseApi } from '@api/baseApi';
import { OrderStatistics } from '@api/shipping-data/types/OrderStatistics';
import { Destination } from '@api/shipping-data/types/Destination';
import { OrderTimelineEvent } from '@api/shipping-data/types/OrderTimelineEvent';



const detailApi = baseApi.injectEndpoints({
	overrideExisting: false,
	endpoints: (builder) => ({

		// customer orders
		getCustomerOrders: builder.query<OrderStatistics[], { date: string, destinationUnvSysId: string }>({
			query: ({ date, destinationUnvSysId }) => ({
				url: 'ShippingDataWeb/GetDayCustomerOrderStatistics',
				params: { date, destinationUnvSysId }
			}),
			providesTags: ['detailStatistics'],
		}),

		resetCustomerOrders: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['detailStatistics'],
		}),

		// customer info
		getCustomerInfo: builder.query<Destination | null, { systemId: string }>({
			query: ({ systemId }) => ({
				url: 'ShippingDataWeb/GetCustomerCardInfo',
				params: { systemId }
			}),
			providesTags: ['customerInfo'],
		}),

		resetCustomerInfo: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['customerInfo'],
		}),

		// order timeline
		getOrderTimeline: builder.query<OrderTimelineEvent[], { unversionedSystemId: string }>({
			query: ({ unversionedSystemId }) => ({
				url: 'ShippingDataWeb/GetOrderTimeline',
				params: { unversionedSystemId }
			}),
			providesTags: ['orderTimeline'],
		}),

		resetOrderTimeline: builder.mutation<null, void>({
			queryFn: () => ({ data: null }),
			invalidatesTags: ['orderTimeline'],
		}),

	}),
});


export const {
	useLazyGetCustomerOrdersQuery,
	useResetCustomerOrdersMutation,
	useLazyGetCustomerInfoQuery,
	useResetCustomerInfoMutation,
	useLazyGetOrderTimelineQuery,
	useResetOrderTimelineMutation } = detailApi;